import { render, staticRenderFns } from "./CourseAttendanceStatus.vue?vue&type=template&id=1650c3db&scoped=true"
import script from "./CourseAttendanceStatus.vue?vue&type=script&lang=js"
export * from "./CourseAttendanceStatus.vue?vue&type=script&lang=js"
import style0 from "./CourseAttendanceStatus.vue?vue&type=style&index=0&id=1650c3db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1650c3db",
  null
  
)

export default component.exports